import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SubscriptionService } from '@core/services/subscription.service';
import { GlobalActions } from '@core/store/global/global.actions';
import { Store } from '@ngrx/store';
import { catchError, finalize, map, of } from 'rxjs';

/**
 * Handles E-Posta fail redirect: marks payment/subscription/contract inactive via API,
 * then allows the payment-failed page. On API/param errors, redirects to return-not-found.
 */
export const epostaRedirectFailGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const subscriptionService = inject(SubscriptionService);
  const store = inject(Store);
  const platformId = inject(PLATFORM_ID);

  const sessionId = route.paramMap.get('SessionId')?.trim();
  const successCode = route.paramMap.get('SuccessCode')?.trim();

  if (!sessionId || !successCode) {
    return router.createUrlTree(['/pricing/return-not-found']);
  }

  if (!isPlatformBrowser(platformId)) {
    return false;
  }

  store.dispatch(GlobalActions.setLoading(true));

  return subscriptionService.failEpostaRedirectPayment(successCode, sessionId).pipe(
    map(() => true),
    catchError(() => of(router.createUrlTree(['/pricing/return-not-found']))),
    finalize(() => store.dispatch(GlobalActions.setLoading(false)))
  );
};
